import { render, staticRenderFns } from "./MailTemplateDrawar.vue?vue&type=template&id=4a3f482e&"
import script from "./MailTemplateDrawar.vue?vue&type=script&lang=js&"
export * from "./MailTemplateDrawar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports